import { BonusMessageType } from "../../../../types";
import { getDictPhrase } from "../../../common";
export const getBonusDetailsCombo = (comboBonusDetails, state) => {
    return {
        type: BonusMessageType.Combo,
        phrase: getDictPhrase(state.dict, "ComboBonusMessage").format(state.formatCurrency(comboBonusDetails.comboBonusWinningsAmount), comboBonusDetails.comboBonusPercentage)
    };
};
//# sourceMappingURL=getBonusDetailsCombo.js.map